import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';
import { HealedHeartMark } from './healed-heart-mark';

type Props = {
  name: ReactNode;
  hasRedeemed: boolean | undefined;
  className?: string;
};

// Fase 28 (28.7.1): wraps a rendered name with the healed-heart scar when
// the member completed redemption. `name` is ReactNode so callers can pass
// a styled span ("@username", "First · Tú", etc.) without restructuring.
export function MemberNameWithScar({
  name,
  hasRedeemed,
  className,
}: Props): ReactNode {
  return (
    <span className={cn('inline-flex items-baseline gap-1', className)}>
      {name}
      {hasRedeemed && <HealedHeartMark />}
    </span>
  );
}
